'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import Image from 'next/image';
import { Heading } from '@/components/ui/Heading';
import Link from 'next/link';
import { SwiperListProps } from '@/core/models/slider-model';
import { useDictionary } from '@/core/hooks/use-dictionary';
import CustomButton from './CustomButton';

export default function SwiperList({ data }: SwiperListProps) {
  const { dictionary } = useDictionary();

  const items = Array.isArray(data.items)
    ? data.items
    : Array.isArray(data.sliderItems)
      ? data.sliderItems
      : [];

  return (
    <div className="w-full col-span-12">
      <div className="flex justify-between items-center mb-10 max-md:flex-col max-md:items-start gap-4">
        <div>
          <Heading level={3}>{data.title}</Heading>
          <p className="text-primary-600">{data.description}</p>
        </div>
        {data.link && (
          <CustomButton>
            <Link href={data.link}>
              {dictionary.ui?.pages.seeAll}
            </Link>
          </CustomButton>
        )}
      </div>
      <Swiper
        modules={[Pagination]}
        spaceBetween={16}
        slidesPerView="auto"
        pagination={{ clickable: true }}
        className="w-full"
        style={{ paddingBottom: '50px' }}
      >
        {items.map((item, index) => {
          const Content = (
            <div className='relative'>
              <div
                className="w-full h-full mb-2 relative"
                style={{ width: '300px', height: '360px' }}
              >
                {(item.image?.url ||
                  item.image_info?.url) && (
                    <Image
                      src={
                        item.image?.url ||
                        item.image_info?.url
                      }
                      alt={item.title || ''}
                      fill
                      className="object-cover rounded-md"
                    />
                  )}
              </div>
              <div className="absolute inset-0 z-0 bg-linear-to-t rounded-md from-black/40 to-white/0" />
              <div className='absolute bottom-3 right-3 left-3'>
                <Heading className='text-primary-0' level={4}>{item.title}</Heading>
                <p className="text-primary-100">{item.description}</p>
              </div>
            </div>
          );

          return (
            <SwiperSlide
              key={index}
              style={{ width: '300px', height: '360px' }}
            >
              {item.link ? <Link href={item.link}>{Content}</Link> : Content}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
